import { Tag } from '..';
import type { TTagProps } from '../types/TProps';

export const TagSearch = ({ className = '', ...props }: TTagProps) => (
  <Tag {...props} className={['tag--search', className].filter(Boolean).join(' ')} />
);
